import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import { validateEditorData } from '../../../editor/defaultOptions.js';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import FormStepsNav from './FormStepsNav.jsx';

import Editor from '../../../editor/editor.jsx';

function StepInformation(props) {
  const {
    handleSubmit,
    onCancel,
    onBack,
    fields,
    updateEditorInstance,
    submitting,
    values,
  } = props;
  return (
    <form>
      <Row className="flex flex-wrap flex-align-start">
        <Col xs={12}>
          <FormStepsNav
            activeIndex={1}
            onSubmit={handleSubmit}
            onBack={onBack}
          />
        </Col>
        {fields
          ? fields.map(({ key, label, isEditor }, index) =>
              isEditor ? (
                <Col key={key} xs={12}>
                  <Field name={key}>
                    {({ name, input, meta }) => {
                      return (
                        <Editor
                          name={name}
                          data={validateEditorData(input.value)}
                          label={label}
                          setEditorInstanceForParent={(editor) =>
                            updateEditorInstance(editor, index)
                          }
                          options={{
                            holder: `${key}-stakeholder-editor`,
                            minHeight: '70',
                          }}
                          customClass="fixed-height"
                          meta={meta}
                        />
                      );
                    }}
                  </Field>
                </Col>
              ) : (
                <Col key={key} xs={12}>
                  <Field
                    name={key}
                    label={label}
                    componentClass="textarea"
                    rows={5}
                    customClass="fixed-height"
                    placeholder="Enter a Value"
                    component={FieldGroup}
                  />
                </Col>
              )
            )
          : null}
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={submitting}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepInformation;
